import requst from './request';

// 获取资源平台信息
export const getFriendshipLink = (data) =>
requst.post("/cmsapi/getFriendshipLink", { ...data });
